/* eslint-disable react/jsx-handler-names */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Toast from "../../atoms/toast";
import { requestToResetLoginSuccessfullToast } from "../../../store/slices/loginSignupSlice";
import AddonSelection from "../../organisms/addonSelection";
import { useABTestingView } from "../../../customHooks/clevertap/useABTestingView";

/**
 * CommonConditionalComponents Component
 *
 * This component handles conditional rendering of common elements.
 * @param {boolean} props.isMobile - Indicates whether the device is mobile, affecting component styling.
 * @returns {React.ReactElement} The rendered CommonConditionalComponents component.
 */
function CommonConditionalComponents({ isMobile, commonCleverTapData, isAddonModalSuppressed = false }) {
  const [isShowToast, setIsShowToast] = useState(false);
  const dispatch = useDispatch();

  const { addToCartErrorMsg, loginSignUpSuccessfullyText, loginSignUpSuccessfully, isProductStockAvailable } =
    useSelector(
      (state) => ({
        addToCartErrorMsg: state?.cart?.addToCartResponse?.errorMsg,
        loginSignUpSuccessfullyText: state?.loginSignUp?.loginSignUpSuccessfullyText,
        loginSignUpSuccessfully: state?.loginSignUp?.loginSignUpSuccessfully,
        isProductStockAvailable: state?.cart?.addToCartResponse?.isProductStockAvailable,
      }),
      shallowEqual,
    );

  const { isShowAddOnBottomSheet } = useABTestingView();

  useEffect(() => {
    if (addToCartErrorMsg && !isProductStockAvailable) {
      setIsShowToast(true);
    }
  }, [addToCartErrorMsg, isProductStockAvailable]);

  return (
    <>
      {isMobile && (
        <Toast
          variant="success"
          isToast={loginSignUpSuccessfully}
          header={loginSignUpSuccessfullyText}
          duration={3000}
          isMobile={true}
          isDrawer={false}
          placement="bottom"
          onToastChange={() => dispatch(requestToResetLoginSuccessfullToast())}
        />
      )}
      <Toast
        variant="error"
        isToast={isShowToast}
        header={addToCartErrorMsg || ""}
        duration={5000}
        isMobile={isMobile}
        onToastChange={() => setIsShowToast(false)}
      />
      <AddonSelection
        isMobile={isMobile}
        commonCleverTapData={commonCleverTapData}
        isShowAddOnBottomSheet={isShowAddOnBottomSheet}
        isSuppressed={isAddonModalSuppressed}
      />
    </>
  );
}

CommonConditionalComponents.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  commonCleverTapData: PropTypes.object,
  isAddonModalSuppressed: PropTypes.bool,
};

export default CommonConditionalComponents;
